import header from "./finance-money-technology-background-concept.jpg";
import section1 from "./close-up-photo-senior-man-sitting-modern-cafe-shop.jpg";
import section2 from "./modern-house-white-floor.jpg";
import section3 from "./young-woman-giving-key.jpg";
import section4de from "./real-estate-concept-property-value-diagram.jpg";
import section4en from "./real-estate-concept-property-value-diagram-en.jpg";
import section5 from "./closeup-unrecognizable-couple-signing-contract.jpg";

export {
  header,
  section1,
  section2,
  section3,
  section4de,
  section4en,
  section5,
};
